/**
 * @flow
 * @relayHash 3c5239da70ca3348c7c318c353b4e32e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Article_viewer$ref = any;
export type queries_Article_QueryVariables = {|
  id: string,
  section: string,
  blockSlug: string,
|};
export type queries_Article_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Article_viewer$ref
  |},
  +spellCheckStatus: ?{|
    +id: ?string,
    +checkId: string,
    +userId: ?string,
    +startedAt: string,
    +response: ?string,
    +passed: boolean,
    +error: ?string,
    +user: ?{|
      +id: string,
      +name: ?string,
    |},
  |},
|};
export type queries_Article_Query = {|
  variables: queries_Article_QueryVariables,
  response: queries_Article_QueryResponse,
|};
*/


/*
query queries_Article_Query(
  $id: ID!
  $section: ID!
  $blockSlug: String!
) {
  viewer {
    ...Article_viewer_icZD9
    id
  }
  spellCheckStatus(id: $id) {
    id
    checkId
    userId
    startedAt
    response
    passed
    error
    user {
      id
      name
    }
  }
}

fragment Article_viewer_icZD9 on Viewer {
  id
  article(id: $id) {
    id
    title
    previewPicture
    foreignAgent
    previewAttribution
    body
    bodyHtml
    lead
    section
    category
    topics {
      id
      name
    }
    linkedArticles {
      id
      title
    }
    author
    hidden
    yaGenre
    isEvent
    infostring
    infostring_hot
    showInYandexNews
    showInYandexZen
    availableAt
    seoTitle
    seoDescription
    seoKeywords
    preview {
      id
      filename
      description
    }
    combinedPreviewVideo {
      id
      filename
      description
    }
    mediaFiles {
      id
    }
    state
    mainPageOrder
    slug
    changes {
      userId
      userName
      modDate
    }
  }
  configurableBlock(slug: $blockSlug) {
    id
    type
    slug
    config
    active
  }
  persons(first: -1, personType: "author") {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
  categories(section: $section) {
    edges {
      node {
        id
        name
      }
    }
  }
  ...TopicSelector_viewer
  ...ArticleSelector_viewer
  me {
    id
    name
    email
    canDelete
  }
}

fragment TopicSelector_viewer on Viewer {
  topicsForSelector: topics(first: -1) {
    edges {
      node {
        id
        name
      }
    }
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "section",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "blockSlug",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = [
  v1,
  v3
],
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "spellCheckStatus",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id",
      "type": "ID!"
    }
  ],
  "concreteType": "SpellCheckStatus",
  "plural": false,
  "selections": [
    v1,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "checkId",
      "args": null,
      "storageKey": null
    },
    v2,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startedAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "response",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "passed",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "error",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": v4
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = [
  v1,
  v6
],
v8 = [
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "filename",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "description",
    "args": null,
    "storageKey": null
  }
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": -1,
  "type": "Int"
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_Article_Query",
  "id": null,
  "text": "query queries_Article_Query(\n  $id: ID!\n  $section: ID!\n  $blockSlug: String!\n) {\n  viewer {\n    ...Article_viewer_icZD9\n    id\n  }\n  spellCheckStatus(id: $id) {\n    id\n    checkId\n    userId\n    startedAt\n    response\n    passed\n    error\n    user {\n      id\n      name\n    }\n  }\n}\n\nfragment Article_viewer_icZD9 on Viewer {\n  id\n  article(id: $id) {\n    id\n    title\n    previewPicture\n    foreignAgent\n    previewAttribution\n    body\n    bodyHtml\n    lead\n    section\n    category\n    topics {\n      id\n      name\n    }\n    linkedArticles {\n      id\n      title\n    }\n    author\n    hidden\n    yaGenre\n    isEvent\n    infostring\n    infostring_hot\n    showInYandexNews\n    showInYandexZen\n    availableAt\n    seoTitle\n    seoDescription\n    seoKeywords\n    preview {\n      id\n      filename\n      description\n    }\n    combinedPreviewVideo {\n      id\n      filename\n      description\n    }\n    mediaFiles {\n      id\n    }\n    state\n    mainPageOrder\n    slug\n    changes {\n      userId\n      userName\n      modDate\n    }\n  }\n  configurableBlock(slug: $blockSlug) {\n    id\n    type\n    slug\n    config\n    active\n  }\n  persons(first: -1, personType: \"author\") {\n    edges {\n      node {\n        id\n        firstName\n        lastName\n      }\n    }\n  }\n  categories(section: $section) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  ...TopicSelector_viewer\n  ...ArticleSelector_viewer\n  me {\n    id\n    name\n    email\n    canDelete\n  }\n}\n\nfragment TopicSelector_viewer on Viewer {\n  topicsForSelector: topics(first: -1) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_Article_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Article_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "blockSlug",
                "variableName": "blockSlug",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": null
              }
            ]
          }
        ]
      },
      v5
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_Article_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "article",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID"
              }
            ],
            "concreteType": "Article",
            "plural": false,
            "selections": [
              v1,
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "previewPicture",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "foreignAgent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "previewAttribution",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "body",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "bodyHtml",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lead",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "section",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "category",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "topics",
                "storageKey": null,
                "args": null,
                "concreteType": "Topic",
                "plural": true,
                "selections": v4
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "linkedArticles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": v7
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "author",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hidden",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "yaGenre",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isEvent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "infostring",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "infostring_hot",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "showInYandexNews",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "showInYandexZen",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "availableAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoTitle",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoDescription",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "seoKeywords",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "preview",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "combinedPreviewVideo",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": false,
                "selections": v8
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "mediaFiles",
                "storageKey": null,
                "args": null,
                "concreteType": "MediaFile",
                "plural": true,
                "selections": [
                  v1
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "mainPageOrder",
                "args": null,
                "storageKey": null
              },
              v9,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "changes",
                "storageKey": null,
                "args": null,
                "concreteType": "Change",
                "plural": true,
                "selections": [
                  v2,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "userName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "modDate",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "configurableBlock",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "slug",
                "variableName": "blockSlug",
                "type": "String"
              }
            ],
            "concreteType": "ConfigurableBlock",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
              },
              v9,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "config",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "persons",
            "storageKey": "persons(first:-1,personType:\"author\")",
            "args": [
              v10,
              {
                "kind": "Literal",
                "name": "personType",
                "value": "author",
                "type": "String"
              }
            ],
            "concreteType": "PersonConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "PersonEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Person",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categories",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "section",
                "variableName": "section",
                "type": "ID!"
              }
            ],
            "concreteType": "CategoryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": false,
                    "selections": v4
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "topicsForSelector",
            "name": "topics",
            "storageKey": "topics(first:-1)",
            "args": [
              v10
            ],
            "concreteType": "TopicConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TopicEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Topic",
                    "plural": false,
                    "selections": v4
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": v7
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v1,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canDelete",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      v5
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '62662c9a9ef5024cc3c9af1fc3f44277';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_Article_Query.graphql.js